import { useRef, useCallback } from "react";
import { useHome } from "../../data/content";
import RotatingTagline from "./RotatingTagline";
import HeroCanvas from "./HeroCanvas";
import HeroCTA from "./HeroCTA";
import ScrollIndicator from "./ScrollIndicator";

function HeroSection({ darkMode }) {
  const home = useHome();
  const mouseRef = useRef({ x: 0, y: 0 });

  const handleMouseMove = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    mouseRef.current = {
      x: ((e.clientX - rect.left) / rect.width) * 2 - 1,
      y: -((e.clientY - rect.top) / rect.height) * 2 + 1,
    };
  }, []);

  return (
    <section
      className="relative h-[95vh] max-h-[1440px] flex flex-col items-center justify-center bg-background-light dark:bg-background-dark px-6 text-center overflow-hidden"
      onMouseMove={handleMouseMove}
    >
      <HeroCanvas mouseRef={mouseRef} darkMode={darkMode} />

      <div className="relative z-10 flex flex-col items-center">
        <p className="font-sans text-xs tracking-[0.3em] text-text-muted-light dark:text-text-muted-dark uppercase mb-8">
          {home.heroEyebrow} {new Date().getFullYear()}
        </p>

        <h1 className="font-serif italic text-[clamp(3.5rem,10vw,8rem)] leading-none text-text-primary-light dark:text-text-primary-dark mb-6">
          {home.heroName}
        </h1>

        <RotatingTagline />

        <p className="font-sans text-sm text-text-muted-light dark:text-text-muted-dark max-w-sm leading-relaxed">
          {home.heroIntro}
        </p>

        <HeroCTA />
      </div>

      <ScrollIndicator />
    </section>
  );
}

export default HeroSection;
